import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_SAVE_FILTER_QUERY_KEY } from "../types/CommonTypes";
import { queryClient } from "../../../utils/ReactQueryConfig";

interface DefaultFilterProps {
  filterId: string;
}

async function updateDefaultFilter(
  tenantId: string,
  hospitalId: string,
  filterId: string
) {
  const { data } = await fetcher({
    url: `/hospital/custom-filters/${filterId}/set-as-default`,
    method: "PUT",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useUpdateDefaultFilterMutation(
  tenantId?: string,
  hospitalId?: string
) {
  return useMutation({
    mutationFn: ({ filterId }: DefaultFilterProps) =>
      updateDefaultFilter(tenantId!, hospitalId!, filterId),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_SAVE_FILTER_QUERY_KEY, hospitalId, tenantId],
      });
    },
  });
}
